export function createRequest(context, request) {
    Object.defineProperties(request, {
        mountname: {
            get: function () {
                // if (process.env.NODE_ENV !== 'production') {
                //   console.warn(`Deprecation Warning: "request.mountname" will be removed in Navi 0.12. Please use "request.mountpath" instead.`)
                // }
                return request.mountpath;
            },
        },
        pathname: {
            get: function () {
                // if (process.env.NODE_ENV !== 'production') {
                //   console.warn(`Deprecation Warning: "request.pathname" will be removed in Navi 0.12. Please use "request.mountpath" instead.`)
                // }
                return request.mountpath;
            }
        },
        context: {
            get: function () {
                // if (process.env.NODE_ENV !== 'production') {
                //   console.warn(`Deprecation Warning: "request.context" will be removed in Navi 0.12. Please use the separate context argument instead.`)
                // }
                return context;
            }
        },
    });
    return request;
}
//# sourceMappingURL=NaviRequest.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/navi/dist/es/NaviRequest.js
// module id = 42
// module chunks = 0